export const formId = 'configuration__settings-form';
export const btnSaveId = 'configuration__button-save';
export const btnAddSettingsId = 'configuration__btn-add-settings';
export const dataTableId = 'configuration__datatable-default-settings';
